export default __webpack_public_path__ + "static/media/location_preview_s2_peary_prairie.40a0aa0f.svg";